export default "__VITE_ASSET__CD78V$Ak__"